"use client";

import React, { useState } from "react";
import Button from "../../atoms/Button";
import Popup from "../Popup";
import Loading from "../../atoms/Loading";
import "./styles.scss";

interface PreviewDocumentProps {
  t: { [key: string]: string };
  fileUrl: string;
  Component: React.ReactElement; // Accept a React element instead of a component reference
}

interface IframeProps {
  fileUrl: string;
  className: string;
}

const PreviewDocument: React.FC<PreviewDocumentProps> = ({ t, fileUrl, Component }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  if (!Component || !fileUrl) return null;

  return (
    <>
      {/* Clone the Component to attach the onClick handler */}
      {React.cloneElement(Component, {
        onClick: handleOpenModal,
        "data-testid": "preview-documents-trigger",
        "aria-label": t["OpenDocument"] || "Open Document",
      })}
      {isOpen && (
        <Popup
          className="previewDocumentPopup"
          onClickOutside={handleCloseModal}
          onKeypressEsc={handleCloseModal}>
          <Iframe
            fileUrl={fileUrl}
            className="previewDocumentPopup_iframe"
          />
          <section className="previewDocumentPopup_action">
            <Button
              onClick={handleCloseModal}
              label={t["Close"]}
              primary
              aria-label={t["Close"] || "Close"}
            />
          </section>
        </Popup>
      )}
    </>
  );
};

const Iframe: React.FC<IframeProps> = ({ fileUrl, className }) => {
  const [iframeLoading, setIframeLoading] = useState(true);

  const handleOnLoadIframe = () => {
    setIframeLoading(false);
  };

  return (
    <>
      {iframeLoading && (
        <div className="previewDocumentPopup_loaderWrapper">
          <Loading />
        </div>
      )}
      <iframe
        data-testid="preview-documents-iframe"
        onLoad={handleOnLoadIframe}
        src={fileUrl}
        className={className}
        title="Document preview"
        aria-label="Document preview"
      />
    </>
  );
};

export default PreviewDocument;
